/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class OverviewRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  async model(params) {
    let group = this.modelFor('group');
    let includeFormer = this.modelFor('group.insights').includeFormer;

    // Strand labels come from the jurisdiction's rubric elements, which the
    // strands tables read out of the store (see strandElements below); without
    // them the tables simply stay hidden. This must finish before the
    // requests below: loading it alongside them left a strand out of the
    // tables.
    let jurisdiction = this.session.school?.jurisdiction;
    if (jurisdiction) {
      await this.store
        .query('reports/rubric', {
          isGlobal: true,
          isActive: true,
          includeElementsAndCriteria: true,
          jurisdiction,
        })
        .catch(() => []);
    }

    return hash({
      group,
      learners: this.store.query('person', {
        groupId: group.id,
        include: 'enrolments',
        includeFormer,
      }),
      subject: this.store.findRecord('goals/subject', params.subject_id),
      progressions: this.store.query('milestones/progression', {
        groupId: group.id,
        latest: true,
        type: ProgressionType.PROGRESSION,
        goalSubjectId: params.subject_id,
      }),
      // Element-level judgements for the strands table. Tolerant by design: if
      // the backend returns no element data the strands section hides rather
      // than breaking the page.
      elementProgressions: this.store
        .query('milestones/progression', {
          groupId: group.id,
          latest: true,
          type: ProgressionType.PROGRESSION,
          goalSubjectId: params.subject_id,
          elements: true,
        })
        .catch(() => []),
      strandElements: this.store.peekAll('reports/rubric-element'),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    this.controllerFor('group/insights/progress').setProperties({
      subjectId: model.subject.id,
      report: 'overview',
    });
  }
}
